const areArraysEqual = (arr1?: any[], arr2?: any[]) => {
  if (!arr1 || !arr2) return false
  if (arr1.length !== arr2.length) return false
  const sortedArr1 = [...arr1].sort()
  const sortedArr2 = [...arr2].sort()
  return sortedArr1.every((value, index) => value === sortedArr2[index])
}

const get = (obj: any, path: string, defaultValue: any = undefined) => {
  const keys = path.split('.')
  let result = obj
  for (const key of keys) {
    result = result?.[key]
    if (result === undefined) return defaultValue
  }
  return result
}

const arrayFilter = (array: any, prop: string, search: string, filterType?: string) => {
  if (!array) return []
  return array.filter((item: any) => {
    if (search === '*' || search === '') return true

    if (filterType === 'includes') return get(item, prop).includes(search)
    if (filterType === 'start-width') return get(item, prop).startWith(search)

    return get(item, prop) === search
  })
}

const arrayUniqueByKey = (array: any, key: string): any[] => {
  if (!array) return []
  return [...new Map(array.map((item: any) => [item[key], item])).values()]
}

export { areArraysEqual, arrayFilter, arrayUniqueByKey }
